// extracted by mini-css-extract-plugin
export default {"divider":"PageItemFactBox_divider__LPhhI"};